import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import Utilities from "../../dependencies/custom/react-utilities";
import domainSettings from "../../dependencies/custom/settings";

export const useCategories = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const fetchCategories = useCallback(async () => {
    setLoading(true);
    try {
      const response = await Utilities.fetchWithAuth(
        "GET",
        domainSettings.urls.bot.categories,
        null,
        navigate,
      );

      if (response.ok) {
        const data = response.data.results || response.data || [];
        setCategories(data);
        // Auto-select first category if none selected
        if (!selectedCategory && data.length > 0) {
          setSelectedCategory(data[0]);
        }
      } else {
        Utilities.showError(response, "Failed to fetch categories");
      }
    } catch (error) {
      message.error("An error occurred while fetching categories");
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [navigate, selectedCategory]);

  const deleteCategory = useCallback(
    async (categoryId) => {
      try {
        const response = await Utilities.fetchWithAuth(
          "DELETE",
          domainSettings.urls.bot.categoryDetail.replace(":id", categoryId),
          null,
          navigate,
        );

        if (response.ok) {
          message.success("Category deleted successfully");
          fetchCategories();
          if (selectedCategory?.id === categoryId) {
            setSelectedCategory(null);
          }
          return true;
        } else {
          Utilities.showError(response, "Failed to delete category");
          return false;
        }
      } catch (error) {
        message.error("An error occurred");
        console.error(error);
        return false;
      }
    },
    [navigate, fetchCategories, selectedCategory],
  );

  return {
    categories,
    loading,
    selectedCategory,
    setSelectedCategory,
    fetchCategories,
    deleteCategory,
  };
};
